// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart {
    width: 100%;
    height: 100%;
    min-height: 350px;
    overflow: hidden;
    border-radius: 10px;
}

.anychart-credits{
    display: none;
}

/* Line chart with comparison: legend + tooltip read on dark widget backgrounds */
.anychart-legend-item {
    font-weight: 600;
    letter-spacing: 0.02em;
}

.line-chart__insights {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.line-chart__insight-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 0.74rem;
    color: rgba(235, 235, 242, 0.95);
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
}

.line-chart__insight-chip--up {
    border-color: rgba(126, 186, 140, 0.6);
    color: rgba(198, 243, 209, 0.96);
}

.line-chart__insight-chip--down {
    border-color: rgba(214, 122, 122, 0.6);
    color: rgba(246, 196, 196, 0.96);
}

.line-chart__controls {
    display: inline-flex;
    gap: 6px;
    margin-bottom: 10px;
}

.line-chart__control-btn {
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(225, 225, 235, 0.95);
    font-size: 0.72rem;
    cursor: pointer;
    transition: all 140ms ease;
}

.line-chart__control-btn:hover {
    border-color: rgba(192, 159, 83, 0.55);
    background: rgba(192, 159, 83, 0.14);
}

.line-chart__control-btn.is-active {
    border-color: rgba(192, 159, 83, 0.78);
    color: rgba(246, 229, 182, 1);
    background: rgba(192, 159, 83, 0.22);
}`, "",{"version":3,"sources":["webpack://./src/Components/Charts/Line/Style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,iFAAiF;AACjF;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,2CAA2C;IAC3C,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,oCAAoC;AACxC","sourcesContent":[".chart {\n    width: 100%;\n    height: 100%;\n    min-height: 350px;\n    overflow: hidden;\n    border-radius: 10px;\n}\n\n.anychart-credits{\n    display: none;\n}\n\n/* Line chart with comparison: legend + tooltip read on dark widget backgrounds */\n.anychart-legend-item {\n    font-weight: 600;\n    letter-spacing: 0.02em;\n}\n\n.line-chart__insights {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.line-chart__insight-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 8px;\n    border-radius: 999px;\n    font-size: 0.74rem;\n    color: rgba(235, 235, 242, 0.95);\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.line-chart__insight-chip--up {\n    border-color: rgba(126, 186, 140, 0.6);\n    color: rgba(198, 243, 209, 0.96);\n}\n\n.line-chart__insight-chip--down {\n    border-color: rgba(214, 122, 122, 0.6);\n    color: rgba(246, 196, 196, 0.96);\n}\n\n.line-chart__controls {\n    display: inline-flex;\n    gap: 6px;\n    margin-bottom: 10px;\n}\n\n.line-chart__control-btn {\n    padding: 4px 10px;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(225, 225, 235, 0.95);\n    font-size: 0.72rem;\n    cursor: pointer;\n    transition: all 140ms ease;\n}\n\n.line-chart__control-btn:hover {\n    border-color: rgba(192, 159, 83, 0.55);\n    background: rgba(192, 159, 83, 0.14);\n}\n\n.line-chart__control-btn.is-active {\n    border-color: rgba(192, 159, 83, 0.78);\n    color: rgba(246, 229, 182, 1);\n    background: rgba(192, 159, 83, 0.22);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
